export default class SvgUtil {
    public static pxToMM = 1 / 3.7795;
    public static pxToPt = 0.75;
}
